import { TFunction } from "i18next";
import { z } from "zod";
import { nullableNumber } from "../../../utils";

export const getFlowTestMeasurementFormSchema = (t: TFunction) => {
  const numberField = nullableNumber(t("generic.errors.invalid-number"));
  return z.object({
    measuredCaptureId: z
      .number({
        required_error: t("flow-tests.flow-test-measurement.errors.measured-capture-required"),
        invalid_type_error: t("flow-tests.flow-test-measurement.errors.measured-capture-required"),
      })
      .positive()
      .min(1, { message: t("flow-tests.flow-test-measurement.errors.measured-capture-required") }),
    variableId: z
      .number({
        required_error: t("flow-tests.flow-test-measurement.errors.variable-required"),
        invalid_type_error: t("flow-tests.flow-test-measurement.errors.variable-required"),
      })
      .positive()
      .min(1, { message: t("flow-tests.flow-test-measurement.errors.variable-required") }),
    measuredAt: z.string().nullable().optional(),
    testingTime: numberField.optional(),
    value: z
      .number({
        required_error: t("flow-tests.flow-test-measurement.errors.value-required"),
        invalid_type_error: t("flow-tests.flow-test-measurement.errors.value-required"),
      }),
    flag: z.string().nullable().optional(),
    notes: z.string().nullable().optional(),
  });
};

export type FlowTestMeasurementForm = z.infer<ReturnType<typeof getFlowTestMeasurementFormSchema>>;